import React from "react";
import { PhoneCall, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

export const Header = () => {
  const isMobile = useIsMobile();
  const { phoneNumber } = usePhoneBar();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      {isMobile ? (
        // Mobile Layout
        <div>
          {/* Logo centered */}
          <div className="container mx-auto px-4 py-2 flex justify-center">
            <img 
              src="/assets/logos/safeway-roofing-logo.png" 
              alt="Safeway Roofing & Chimney - Professional Roofing Contractor Long Island NY" 
              className="h-32 w-auto object-contain"
            />
          </div>
          
          {/* Mobile Menu Bar - Full Width */}
          <div className="flex text-white">
            {/* Phone Section - Blue Background */}
            <a 
              href={`tel:${phoneNumber}`}
              className="flex items-center space-x-2 bg-blue-700 hover:bg-blue-800 text-white transition-colors flex-1 min-h-[24px] px-4 py-1"
            >
              <PhoneCall className="w-5 h-5" />
              <span className="font-medium text-lg">{phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span>
            </a>
            
            {/* Menu Section - Black Background */}
            <div className="bg-black min-h-[24px] flex items-center px-4 py-1">
              <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
                <SheetTrigger asChild>
                  <button className="flex items-center space-x-2 p-2 text-white hover:bg-gray-800 rounded-md transition-colors" aria-label="Open menu">
                    <span className="font-medium">Menu</span>
                    <Menu className="w-5 h-5" />
                  </button>
                </SheetTrigger>
                <SheetContent side="right">
                  <SheetHeader>
                    <SheetTitle>Menu</SheetTitle>
                  </SheetHeader>
                  <div className="mt-6 space-y-4">
                    <div className="space-y-2">
                      <a href="#services" onClick={handleNavClick} className="block text-lg hover:text-primary transition-colors">Services</a>
                      <a href="#testimonials" onClick={handleNavClick} className="block text-lg hover:text-primary transition-colors">Testimonials</a>
                      <a href="#faq" onClick={handleNavClick} className="block text-lg hover:text-primary transition-colors">FAQ</a>
                      <a href="#gallery" onClick={handleNavClick} className="block text-lg hover:text-primary transition-colors">Gallery</a>
                      <a href="#coupons" onClick={handleNavClick} className="block text-lg hover:text-primary transition-colors">Coupons</a>
                      <a href="/book-appointment" onClick={handleNavClick} className="block text-lg hover:text-primary transition-colors">Book Appointment</a>
                    </div>
                    <div className="pt-4 border-t">
                      <a 
                        href={`tel:${phoneNumber}`}
                        className="flex items-center space-x-2 text-primary font-semibold text-lg"
                      >
                        <PhoneCall className="w-5 h-5" />
                        <span>Call Now: {phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span>
                      </a>
                    </div>
                  </div>
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      ) : (
        // Desktop Layout  
        <header className="bg-background/95 backdrop-blur-sm border-b border-border/50">
          <div className="container mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <img 
                  src="/assets/logos/safeway-roofing-logo.png" 
                  alt="Safeway Roofing & Chimney - Licensed Roofing Contractor Long Island" 
                  className="h-20 w-auto object-contain"
                />
              </div>
              
              {/* Desktop Navigation */}
              <nav className="hidden lg:flex items-center space-x-8">
                <a href="#services" className="text-foreground hover:text-primary transition-colors font-medium">Services</a>
                <a href="#testimonials" className="text-foreground hover:text-primary transition-colors font-medium">Testimonials</a>
                <a href="#faq" className="text-foreground hover:text-primary transition-colors font-medium">FAQ</a>
                <a href="#gallery" className="text-foreground hover:text-primary transition-colors font-medium">Gallery</a>
                <a href="#coupons" className="text-foreground hover:text-primary transition-colors font-medium">Coupons</a>
                <a href="/book-appointment" className="text-foreground hover:text-primary transition-colors font-medium">Book Now</a>
              </nav>
              
              <Button
                variant="default"
                size="lg"
                className="bg-primary-dark hover:bg-primary-dark/90 text-primary-foreground font-semibold px-6 py-3 shadow-md hover:shadow-lg transition-all duration-200"
                asChild
              >
                <a href={`tel:${phoneNumber}`}>
                  <PhoneCall className="w-4 h-4 mr-2" />
                  {phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}
                </a>
              </Button>
            </div>
          </div>
        </header>
      )}
    </>
  );
};